<template>
	<AdminLayout>
		<div class="flex flex-row mb-4">
			<p class="admin-center-subtitle">Organization Groups</p>
			<SubmitButton label="Create New" @click="onAddClicked" size="small"/>
		</div>

		<PortalDataTable
			ref="table"
			:endpoints="endpoints"
		>
			<template #name="data">
				<p class="endpoint-clickable-text whitespace-pre-wrap lg:whitespace-nowrap"
				   @click.prevent="onOrganizationGroupClicked(data.value)">
					{{ data.value.name }}
				</p>
			</template>
		</PortalDataTable>
	</AdminLayout>

	<Teleport to="html" v-if="organizationGroupToEdit">
		<OrganizationGroupEditModal :show="true" :organization-group-to-edit="organizationGroupToEdit" @dismiss="onEditModalDismiss" />
	</Teleport>
</template>

<script setup lang="js">
import { ref } from 'vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import OrganizationGroupEditModal from '@/views/Admin/OrganizationGroups/OrganizationGroupEditModal.vue'
import PortalDataTable from '@/components/DataTable/PortalDataTable.vue'
import { DataTableEndpointDefinition } from '@/models/datatable/DataTableEndpointDefinition.js'

const table = ref(null)
const columns = [
	{ field: "name", title: "Name", search: true },
]

const endpoints = [
	new DataTableEndpointDefinition({
		endpointRoute: 'organization-groups',
		initialSortColumn: 'name',
		searchPlaceholder: 'Search by name',
		columns: columns,
	})
]

const organizationGroupToEdit = ref(null)

function onAddClicked() {
	organizationGroupToEdit.value = {}
}

function onOrganizationGroupClicked(organizationGroup) {
	organizationGroupToEdit.value = organizationGroup
}

function onEditModalDismiss(reload) {
	organizationGroupToEdit.value = null

	if (reload) {
		if (table.value) {
			table.value.loadData()
		} else {
			location.reload()
		}
	}
}

</script>